import React from "react";
import logo from "../../Assets/Images/Ciqlercompined2024.png";
import { Link } from "react-router-dom";

// Logo Component
function Logo() {
  return (
    <Link to="/" className="flex items-center justify-start w-full">
      <img
        className="max-w-full aspect-[4.76] w-[130px] hover:cursor-pointer"
        src={logo}
        alt="Logo"
      />
    </Link>
  );
}

// NavBar Component
export default function NavBar() {
  return (
    <header className="flex h-20 w-full items-center justify-between px-4 md:px-6 bg-grey-100 border-b border-gray-300">
      <Logo />
      <nav className="flex gap-1 items-center">
        <Link
          to="/auth?tab=signup"
          className="whitespace-nowrap px-4 py-2 border border-transparent text-sm font-medium rounded-md text-grey-100 bg-red-300 hover:bg-red-400"
        >
          Shopify Sign Up
        </Link>
      </nav>
    </header>
  );
}
